import {StyleSheet} from 'react-native';

import {black, denim, white} from '/theme/color/on.color';
import {
  alto,
  codGray,
  graniteGray,
  mineShaft,
} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: white,
    paddingHorizontal: 0,
  },
  topView: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  base: {
    flex: 1,
    paddingBottom: 0,
    backgroundColor: white,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    paddingEnd: 16,
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    color: codGray,
    paddingStart: 16,
  },
  learnMore: {
    fontSize: 14,
    color: denim,
  },
  separator: {
    height: 1,
    backgroundColor: alto,
    marginVertical: 16,
  },
  sectionTitle: {
    fontSize: 20,
    paddingStart: 16,
    color: mineShaft,
    paddingBottom: 16,
    paddingTop: 32,
  },
  sectionTitleFocused: {
    borderWidth: 4,
    borderColor: black,
    borderRadius: 8,
  },
  categoryContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 16,
    paddingRight: 5,
  },
  categoryButton: {
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: '#ccc',
    marginRight: 10,
    backgroundColor: white,
    overflow: 'hidden',
  },
  categoryButtonSelected: {
    borderColor: denim,
    borderWidth: 3,
    backgroundColor: white,
  },
  categoryButtonFocused: {
    borderWidth: 4,
    borderColor: black,
    borderRadius: 24,
    shadowColor: black,
    shadowOffset: {width: 0, height: 0},
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 4,
  },
  categoryText: {
    fontSize: 14,
    color: codGray,
  },
  categoryTextFocused: {
    color: black,
    fontWeight: '800',
  },
  flatList: {
    paddingStart: 16,
    paddingEnd: 16,
  },
  planCard: {
    backgroundColor: white,
    padding: 24,
    gap: 24,
    borderRadius: 8,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: alto,
  },

  selectedPlanCard: {
    borderWidth: 4,
    borderColor: denim,
    borderRadius: 8,
  },
  planTitle: {
    fontSize: 20,
    lineHeight: 24,
    color: graniteGray,
    marginTop: 0,
    marginBottom: 4,
  },
  planTitleSelected: {
    fontSize: 22,
    lineHeight: 26,
    color: graniteGray,
    marginTop: 0,
    marginBottom: 4,
    fontWeight: 'bold',
  },
  planTite: {
    fontSize: 14,
    marginBottom: 4,
    color: graniteGray,
  },
  planName: {
    fontSize: 20,
    lineHeight: 24,
    color: codGray,
    marginTop: 0,
    marginBottom: 8,
  },
  tabNavigationContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 50,
    marginBottom: 5,
    paddingTop: 5,
  },
  navigationArrow: {
    minWidth: 40, // WCAG 2.2 AA compliant touch target
    minHeight: 40,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 0,
  },
  navigationArrowText: {
    fontSize: 37,
    color: black,
  },
  navigationArrowDisabled: {
    opacity: 0.5,
    borderWidth: 0,
  },
  navigationArrowFocused: {
    borderWidth: 4,
    borderColor: black,
    borderRadius: 4,
    shadowColor: black,
    shadowOffset: {width: 0, height: 0},
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 4,
  },
  tabScrollView: {
    flex: 1,
  },
  planDescription: {
    fontSize: 16,
    lineHeight: 24,
    color: codGray,
    marginBottom: 12,
  },
  selectButton: {
    minHeight: 40,
    paddingVertical: 8,
    backgroundColor: white,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: alto,
  },
  selectButtonText: {
    fontSize: 14,
    color: codGray,
    textAlignVertical: 'center',
    textAlign: 'center',
    lineHeight: 18,
    flex: 1,
    flexWrap: 'wrap',
    flexShrink: 1,
    maxWidth: '100%',
  },
  selectedButton: {
    backgroundColor: white,
    minHeight: 40,
    paddingVertical: 8,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 4,
    borderColor: denim,
  },
  selectedButtonText: {
    color: codGray,
    fontSize: 18,
    textAlignVertical: 'center',
    textAlign: 'center',
    lineHeight: 22,
    flex: 1,
    flexWrap: 'wrap',
    flexShrink: 1,
    maxWidth: '100%',
  },
  buttonWithIcon: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
  },
  buttonIcon: {
    fontSize: 16,
    color: codGray,
  },
  navigationArrowTextIOS: {
    fontSize: 32,
    color: black,
    fontWeight: '700',
    lineHeight: 32,
    textAlign: 'center',
    includeFontPadding: false,
    marginTop: -2,
  },
  planCardOverlayFocused: {
    borderWidth: 4,
    borderColor: black,
    borderRadius: 8,
  },
  planCardFocused: {
    borderWidth: 4,
    borderColor: black,
    borderRadius: 8,
    shadowColor: black,
    shadowOffset: {width: 0, height: 0},
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 4,
  },
  selectedPlanCardFocused: {
    borderWidth: 4,
    borderColor: denim,
    borderRadius: 8,
    shadowColor: black,
    shadowOffset: {width: 0, height: 0},
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 4,
  },
  selectButtonFocused: {
    borderWidth: 4,
    borderColor: black,
    borderRadius: 8,
    shadowColor: black,
    shadowOffset: {width: 0, height: 0},
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 4,
  },
  planTitleFocused: {
    color: black,
    fontWeight: '800',
  },

  planNameFocused: {
    color: black,
    fontWeight: '700',
  },

  planDescriptionFocused: {
    color: black,
    fontWeight: '700',
  },
  selectButtonTextFocused: {
    color: black,
    fontWeight: '800',
  },
});
